export function imageOnly(){ return !!this.options.imageOnly }

export function nonImageOnly(){ return !!this.options.nonImageOnly }